import { useBaseCheckboxRadio } from '../VBaseCheckboxRadio';
import { useBaseCheckboxRadioGroup } from '../VBaseCheckboxRadioGroup/hook';
import { RadioButtonChecked, RadioButtonUnchecked } from '../asset';
import style from './style';
import type { VRadioGroupInnerItemProps } from './type';

const VRadioGroupInnerItem = (props: VRadioGroupInnerItemProps) => {
  const { value: innerValue, onValueChange } = useBaseCheckboxRadioGroup();
  const { id, disabled } = useBaseCheckboxRadio();

  const checked = innerValue === props.value || innerValue === id;
  const Icon = checked ? RadioButtonChecked : RadioButtonUnchecked;

  const handleChange = () => {
    if (!disabled) {
      onValueChange?.(props.value);
    }
  };

  const _style = style(props);

  return (
    <>
      <input
        type="radio"
        id={id}
        checked={checked}
        onChange={handleChange}
        style={{
          position: 'absolute',
          opacity: 0,
          pointerEvents: 'none',
          width: 0,
          height: 0,
        }}
        tabIndex={-1}
        aria-hidden="true"
        disabled={disabled}
      />
      <Icon
        className={_style.icon}
        role="radio"
        aria-checked={checked}
        onClick={handleChange}
      />
    </>
  );
};

export default VRadioGroupInnerItem;
